'use client'

import { useSearchParams } from 'next/navigation'
import { useTranslations } from 'next-intl'

/**
 * Calm, localized notice shown on the login page when a session has ended for
 * an EXPECTED reason (refresh token expired / invalidated). The API client
 * appends `?reason=expired` to the redirect (see services/api.ts errorHandler);
 * this reads that flag and renders an informational banner instead of leaving
 * the user on a bare login form with no context. Renders nothing otherwise.
 *
 * Uses `useSearchParams`, so the caller must wrap it in a <Suspense> boundary
 * (Next.js 14 App Router requirement) to avoid de-opting the page to CSR.
 */
export default function SessionExpiredBanner() {
  const t = useTranslations('auth')
  const searchParams = useSearchParams()

  if (searchParams.get('reason') !== 'expired') {
    return null
  }

  return (
    <div
      role="status"
      className="rounded-md border border-amber-300 bg-amber-50 px-4 py-3 text-amber-900 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-200"
    >
      <p className="text-sm font-medium">{t('sessionExpiredTitle')}</p>
      <p className="text-sm">{t('sessionExpiredMessage')}</p>
    </div>
  )
}
